import { render } from "./paginaTreinador.vue?vue&type=template&id=19ce0f8e"
import script from "./paginaTreinador.vue?vue&type=script&lang=js"
export * from "./paginaTreinador.vue?vue&type=script&lang=js"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__